export default __webpack_public_path__ + "static/media/con_MOVG06.f190b694.jpg";